var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"elevation-0 agenda-page agenda-page-container page"},[(_vm.isBlocked)?_c('PageBlocked',{attrs:{"blockRole":_vm.blockRole}}):(_vm.isBlocked !== null)?_c('Agendas'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }